import { isCreditVisible } from './helpers/hideCredits';
import { addDNoneClass, byId } from './helpers/utility';


const footerElement = byId('footer');

if(isCreditVisible()){
    addDNoneClass(footerElement,false);
}